import React from "react";

import SignInForm from "../components/SignIn";

const SignIn = () => {
  return <SignInForm />;
};

export default SignIn;
